module.exports = __webpack_public_path__ + "media/ru_ru_s4_Vova.d47fcf6b.oga";